class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    if (new URLSearchParams(window.location.search).get('cart_saved') === '1') {
      this.handleIntersection([{ isIntersecting: true }], { unobserve() {} });
    } else {
      new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          this.showShoppingNotice();
      })
      .catch(e => {
        console.error(e);
      });
  }

  showShoppingNotice() {
    if (new URLSearchParams(window.location.search).get('cart_saved') !== '1' || document.querySelector('.sm-cart-saved')) return;
    const form = this.querySelector('form.mini-cart');
    const main = document.getElementById('MainContent');
    if (!form || form.classList.contains('is-empty') || !main) return;
    const notice = document.createElement('aside');
    notice.className = 'sm-cart-saved';
    notice.setAttribute('role', 'status');
    const copy = document.createElement('div');
    copy.className = 'sm-cart-saved__copy';
    const message = document.createElement('p');
    message.textContent = form.dataset.savedMessage;
    const arabic = document.createElement('p');
    arabic.lang = 'ar';
    arabic.dir = 'rtl';
    arabic.textContent = form.dataset.savedMessageAr;
    copy.append(message, arabic);
    const open = document.createElement('button');
    open.type = 'button';
    open.className = 'sm-cart-saved__open';
    const englishLabel = document.createElement('span');
    englishLabel.textContent = form.dataset.viewCart;
    const arabicLabel = document.createElement('span');
    arabicLabel.lang = 'ar';
    arabicLabel.dir = 'rtl';
    arabicLabel.textContent = form.dataset.viewCartAr;
    open.append(englishLabel, arabicLabel);
    open.addEventListener('click', () => this.open());
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'sm-cart-saved__close';
    close.setAttribute('aria-label', form.dataset.closeMessage);
    close.textContent = '×';
    close.addEventListener('click', () => notice.remove());
    notice.append(copy, open, close);
    main.prepend(notice);
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
